import _ from "lodash";
import { contactTypeTypes } from "./contactTypeTypes";
import { contactsApi } from "./contactTypesApi";
export const ON_SELECT_CONTACT_AREA = "ON_SELECT_CONTACT_AREA";

const onGetAllContactTypes = modal => async dispatch => {
  let data = await contactsApi.getAllContactTypes(modal);
  return data;
};
const onGetAllContactDataFields = id => async dispatch => {
  let data = await contactsApi.getAllContactDataFields(id);
  return data;
};
const onGetAllContactModules = id => async dispatch => {
  let data = await contactsApi.getAllContactModules(id);
  return data;
};
const onGetAllConnections = id => async dispatch => {
  let data = await contactsApi.getAllConnections(id);
  return data;
};
const onGetAllContactAreas = () => async dispatch => {
  let data = await contactsApi.getAllContactAreas();
  return data;
};
const onGetAllOfishRoles = () => async dispatch => {
  let data = await contactsApi.getAllOFisRoles();
  return data;
};
const onGetAllContactDataFieldsById = _ID => async dispatch => {
  let data = await contactsApi.getAllContactDataFieldsById(_ID);
  return data;
};

const onDeleteContactType = _ID => async dispatch => {
  const data = await contactsApi.deleteContactTypeData(_ID);
  return data;
};

const onSelectContactArea = value => async dispatch => {
  dispatch({
    type: "ON_SELECT_CONTACT_AREA",
    payload: value,
  });
};

const getContactTypesModulesFiledsSettingsById = id => async dispatch => {
  let data = await contactsApi.getContactTypesModulesFiledsSettingsById(id);
  return data;
};

const onChange = (prop, value) => async dispatch => {
  dispatch({
    type: contactTypeTypes.ON_CHANGE,
    payload: { prop, value },
  });
};

const onAddUpdateContactType = modal => async dispatch => {
  let data = await contactsApi.addUpdateContactType(modal);
  return data;
};

const onGetContactTypesById = id => async dispatch => {
  let data = await contactsApi.getContactTypesById(id);
  return data;
};

const onAddUpdateMarkFavouriteContactTypes = modal => async dispatch => {
  let data = await contactsApi.addUpdateMarkFavouriteContactTypes(modal);
  return data;
};

const onAddUpdateMarkFavouriteContactTypesModules = modal => async dispatch => {
  let data = await contactsApi.addUpdateMarkFavouriteContactTypesModules(modal);
  return data;
};

const onAddUpdateMarkFavouriteOfishConnections = modal => async dispatch => {
  let data = await contactsApi.addUpdateMarkFavouriteOfishConnections(modal);
  return data;
};

const onGetFavouriteUser = () => async dispatch => {
  let data = await contactsApi.getFavouriteUsers();
  return data;
};

const onGetStoreLocationsByCompanyId = id => async dispatch => {
  let data = await contactsApi.getStoreLocationsByCompanyId(id);
  return data;
};

const onGetLeadsPaginatedData = modal => async dispatch => {
  let data = await contactsApi.getLeadsPaginatedData(modal);
  return data;
};

const onUpdateLeadGeneration = data => async dispatch => {
  let response = await contactsApi.updateLeadGeneration(data);
  return response;
};

const onGetLeadGeneration = id => async dispatch => {
  let data = await contactsApi.getLeadGeneration(id);
  return data;
};

const onGetCompaignByLeadId = id => async dispatch => {
  let data = await contactsApi.getCompaignByLeadId(id);
  return data;
};

const onGetProspectPaginatedData = modal => async dispatch => {
  let data = await contactsApi.getProspectsPaginatedData(modal);
  return data;
};

const onGetProspectNotes = modal => async dispatch => {
  let data = await contactsApi.getProspectNotes(modal);
  return data;
};

const onAddProspectNotes = modal => async dispatch => {
  let data = await contactsApi.addProspectNotes(modal);
  return data;
};

const onGetProspectById = modal => async dispatch => {
  let data = await contactsApi.getProspectById(modal);
  return data;
};

const onAddProspectFollowUp = modal => async dispatch => {
  let data = await contactsApi.addProspectFollowUp(modal);
  return data;
};

const onGetProspectFollowUp = modal => async dispatch => {
  let data = await contactsApi.getProspectFollowUp(modal);
  return data;
};

const onGetProspectInteraction = modal => async dispatch => {
  let data = await contactsApi.getProspectInteraction(modal);
  return data;
};

const onAddProspectInteraction = modal => async dispatch => {
  let data = await contactsApi.addProspectInteraction(modal);
  return data;
};

const onAddProspect = modal => async dispatch => {
  let data = await contactsApi.addProspect(modal);
  return data;
};

const onUploadProspect = prospect => async dispatch => {
  try {
    let data = await contactsApi.uploadProspect(prospect);
    return { success: true, data };
  } catch (error) {
    console.error("Upload prospect action error:", error);
    return { success: false, error: error.message };
  }
};

const onConvertProspect = modal => async dispatch => {
  let data = await contactsApi.convertProspect(modal);
  return data;
};

const onGetVoiceToke = () => async dispatch => {
  let data = await contactsApi.getVoiceToken();
  return data;
};

const onDeleteProspect = prospectId => async dispatch => {
  let data = await contactsApi.deleteProspect(prospectId);
  return data;
};

const onGetAllProspectsList = () => async dispatch => {
  let data = await contactsApi.getAllProspectsList();
  return data;
};

export const contactsTypesActions = {
  onGetAllContactTypes: onGetAllContactTypes,
  onGetAllContactDataFields: onGetAllContactDataFields,
  onGetAllContactModules: onGetAllContactModules,
  onGetAllConnections: onGetAllConnections,
  onGetAllContactAreas: onGetAllContactAreas,
  onGetAllOfishRoles: onGetAllOfishRoles,
  onSelectContactArea: onSelectContactArea,
  onGetAllContactDataFieldsById: onGetAllContactDataFieldsById,
  // onGetContactTypeDetailByID: onGetContactTypeDetailByID,
  // onAddContactType: onAddContactType,
  // onChangeContactTypeStatus: onChangeContactTypeStatus,
  // onUpdateContactType: onUpdateContactType,
  getContactTypesModulesFiledsSettingsById:
    getContactTypesModulesFiledsSettingsById,
  onChange: onChange,
  onAddUpdateContactType: onAddUpdateContactType,
  onGetContactTypesById: onGetContactTypesById,
  onAddUpdateMarkFavouriteContactTypes: onAddUpdateMarkFavouriteContactTypes,
  onAddUpdateMarkFavouriteContactTypesModules:
    onAddUpdateMarkFavouriteContactTypesModules,
  onAddUpdateMarkFavouriteOfishConnections:
    onAddUpdateMarkFavouriteOfishConnections,
  onGetFavouriteUser: onGetFavouriteUser,
  onGetStoreLocationsByCompanyId: onGetStoreLocationsByCompanyId,
  onGetLeadsPaginatedData: onGetLeadsPaginatedData,
  onUpdateLeadGeneration: onUpdateLeadGeneration,
  onGetLeadGeneration: onGetLeadGeneration,
  onGetCompaignByLeadId: onGetCompaignByLeadId,
  onDeleteContactType: onDeleteContactType,
  onGetProspectPaginatedData: onGetProspectPaginatedData,
  onGetProspectNotes: onGetProspectNotes,
  onAddProspectNotes: onAddProspectNotes,
  onGetProspectById: onGetProspectById,
  onAddProspectFollowUp: onAddProspectFollowUp,
  onGetProspectFollowUp: onGetProspectFollowUp,
  onGetProspectInteraction: onGetProspectInteraction,
  onAddProspectInteraction: onAddProspectInteraction,
  onAddProspect: onAddProspect,
  onUploadProspect: onUploadProspect,
  onConvertProspect: onConvertProspect,
  onGetVoiceToke: onGetVoiceToke,
  onDeleteProspect: onDeleteProspect,
  onGetAllProspectsList: onGetAllProspectsList,
};
